// extracted by mini-css-extract-plugin
module.exports = {"countdown-timer":"_2ab8H5"};